var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankuBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 428,
    viewBox: "0 0 580 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0771 51.4379L452.026 11.8906L580 225.448L517.567 427.365H75.7644L0 262.738L61.0771 51.4379Z",
    fill: "#FEEBDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.046 23.1855H138.844C136.144 23.1855 133.955 25.3744 133.955 28.0745C133.955 30.7747 136.144 32.9635 138.844 32.9635H255.046C257.747 32.9635 259.936 30.7747 259.936 28.0745C259.936 25.3744 257.747 23.1855 255.046 23.1855Z",
    fill: "#522C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.971 360.484H27.0199C24.3198 360.484 22.1309 362.673 22.1309 365.373C22.1309 368.074 24.3198 370.262 27.0199 370.262H114.971C117.671 370.262 119.86 368.074 119.86 365.373C119.86 362.673 117.671 360.484 114.971 360.484Z",
    fill: "#522C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.953 92.3206H95.1684C95.1684 92.3206 89.9656 72.552 79.4183 77.4512C71.3206 81.2267 73.2641 88.211 74.5901 91.2072C74.8603 91.8608 75.3568 92.3954 75.9887 92.7132C76.6206 93.031 77.3457 93.1108 78.0316 92.9381C79.8435 92.4117 81.6655 89.9014 80.3395 81.2571C78.8313 71.4993 70.693 67.2581 66.6442 65.4665C65.4007 64.9201 64.0599 64.6295 62.7018 64.6122C61.3436 64.5948 59.9959 64.8509 58.7388 65.3653C54.0218 67.2885 46.9262 72.3395 47.8979 85.2958C47.9672 86.6244 48.3376 87.9199 48.9812 89.0843C49.6247 90.2487 50.5246 91.2515 51.6128 92.017C52.5446 92.7057 53.6728 93.0774 54.8316 93.0774C55.9904 93.0774 57.1186 92.7057 58.0505 92.017C59.3748 91.1066 60.4348 89.862 61.1228 88.4096C61.8107 86.9572 62.1023 85.3486 61.9677 83.7471C61.6236 78.6861 59.5485 70.4264 50.0843 66.418C35.9133 60.4459 27.9168 78.8177 26.2871 93.0899",
    stroke: "#522C2C",
    strokeWidth: 2.02443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456.266 368.388H507.625C507.625 368.388 510.409 348.943 520.784 353.751C528.771 357.466 526.858 364.318 525.532 367.274C525.272 367.9 524.803 368.417 524.205 368.734C523.606 369.052 522.916 369.151 522.252 369.015C520.44 368.57 518.537 366.211 519.873 357.506C521.341 347.951 527.131 343.77 531.109 341.999C532.337 341.452 533.663 341.159 535.008 341.136C536.352 341.114 537.687 341.362 538.933 341.868C543.6 343.76 553.823 355.107 555.129 367.962",
    stroke: "#522C2C",
    strokeWidth: 2.02443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5371 413.391H53.7057",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8262 413.391H94.9741",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M470.357 413.391H502.495",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512.07 413.391H530.371",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.434 413.391H464.08",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M531.392 318.784C539.403 318.784 545.897 312.289 545.897 304.279C545.897 296.268 539.403 289.773 531.392 289.773C523.381 289.773 516.887 296.268 516.887 304.279C516.887 312.289 523.381 318.784 531.392 318.784Z",
    fill: "#522C2C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.689 154.067C386.692 154.067 389.936 150.822 389.936 146.82C389.936 142.817 386.692 139.572 382.689 139.572C378.686 139.572 375.441 142.817 375.441 146.82C375.441 150.822 378.686 154.067 382.689 154.067Z",
    fill: "#522C2C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M544.523 91.8881C546.877 91.8881 548.785 89.9802 548.785 87.6267C548.785 85.2731 546.877 83.3652 544.523 83.3652C542.17 83.3652 540.262 85.2731 540.262 87.6267C540.262 89.9802 542.17 91.8881 544.523 91.8881Z",
    fill: "#522C2C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.124 15.372C320.312 15.372 323.706 11.9776 323.706 7.79047C323.706 3.60333 320.312 0.208984 316.124 0.208984C311.937 0.208984 308.543 3.60333 308.543 7.79047C308.543 11.9776 311.937 15.372 316.124 15.372Z",
    fill: "#522C2C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.702 146.168C161.967 146.168 164.614 143.522 164.614 140.257C164.614 136.992 161.967 134.346 158.702 134.346C155.438 134.346 152.791 136.992 152.791 140.257C152.791 143.522 155.438 146.168 158.702 146.168Z",
    fill: "#522C2C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9337 310.156C49.2928 310.156 51.2052 308.244 51.2052 305.885C51.2052 303.526 49.2928 301.613 46.9337 301.613C44.5746 301.613 42.6621 303.526 42.6621 305.885C42.6621 308.244 44.5746 310.156 46.9337 310.156Z",
    fill: "#522C2C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M459.658 130.783L479.143 204.23C479.143 204.23 483.101 234.171 482.534 237.279C481.967 240.386 484.559 252.816 485.642 254.223C486.725 255.63 486.209 268.394 485.075 270.894C483.941 273.394 483.243 287.09 484.943 289.742C486.644 292.394 487.342 312.01 481.836 314.956",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M459.19 123.071L466.397 131.351L455.587 135.318L455.83 124.012C437.559 124.265 408.418 95.842 400.897 72.9254C392.738 48.0654 404.946 21.7275 428.227 14.1056C451.508 6.48356 476.904 20.4622 485.052 45.3324C492.745 68.8867 476.094 113.515 459.19 123.071Z",
    fill: "#0160FA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M484.519 130.783L476.32 217.5C476.32 217.5 478.02 241.793 480.368 248.008C482.322 253.069 480.277 261.896 476.077 268.202C473.238 272.461 471.499 277.358 471.016 282.454C470.583 286.79 470.699 291.163 471.36 295.471C473.334 307.476 464.861 308.043 464.861 308.043",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M486.068 126.058L494.085 136.656L474.549 136.018L482.586 125.896C465.146 120.835 446.318 87.0774 446.318 64.5455C446.318 52.8059 450.982 41.5471 459.283 33.2459C467.584 24.9448 478.843 20.2813 490.583 20.2812C502.322 20.2813 513.581 24.9448 521.882 33.2459C530.183 41.5471 534.847 52.8059 534.847 64.5455C534.847 87.7354 505.118 122.495 486.068 126.058Z",
    fill: "#FF2B49"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M342.812 413.388H281.036L277.271 392.485L276.147 413.388H209.482L210.586 325.254H337.538L342.812 413.388Z",
    fill: "#522C2C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.57 329.674L268.886 356.7C268.886 356.7 269.736 370.446 278.492 374.495L279.15 386.641",
    stroke: "#FEEBDC",
    strokeWidth: 2.02443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.939 240.793C109.525 250.207 99.2716 247.879 89.858 238.506L70.4032 217.533C68.8495 218.351 67.0534 218.585 65.3421 218.191C63.9131 217.951 62.6189 217.204 61.6981 216.085L55.4122 208.494C51.4545 200.021 60.4733 201.155 60.4733 201.155C56.9508 190.132 67.9637 193.239 67.9637 193.239L53.8433 173.471C49.3187 167.114 52.2845 163.582 52.2845 163.582C54.4911 158.197 61.7082 164.027 62.022 164.28C61.5554 163.525 61.4002 162.619 61.5891 161.752C61.7779 160.885 62.2961 160.126 63.0342 159.634C66 156.8 70.2311 161.749 70.2311 161.749L115.173 210.235C124.617 219.648 128.312 231.38 118.939 240.793Z",
    fill: "#FDAFA2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.918 164.43C61.918 164.43 75.1881 180.534 76.6052 184.765",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 194.936C71.2402 194.936 78.9635 203.762 78.9331 208.003C78.9331 208.003 78.2043 215.089 71.2402 211.131C71.2402 211.131 74.206 216.759 71.2402 217.204",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3145 204.121L71.238 211.136",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0771 192.4C97.0771 192.4 73.209 190.133 78.928 200.022C78.928 200.022 79.424 203.554 90.4369 202.704C90.4369 202.704 93.9696 208.079 97.0771 208.778H106.683",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M488.465 226.569C488.465 226.569 483.91 232.643 477.503 230.79C477.503 230.79 474.375 229.535 475.62 226.853L456.671 243.393C449.333 250.731 439.737 246.49 436.649 241.236C431.396 232.288 430.85 221.124 438.188 213.785L470.387 190.697C470.387 190.697 478.727 183.915 484.558 193.237C484.558 193.237 487.665 196.203 484.558 197.62C484.558 197.62 493.88 198.329 487.665 205.718C487.665 205.718 491.188 209.392 488.364 211.791C488.364 211.791 490.773 217.166 488.647 218.715C488.607 218.664 492.281 223.745 488.465 226.569Z",
    fill: "#FDAFA2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M469.586 203.215C469.586 203.215 477.684 199.835 478.058 194.936C478.058 194.936 482.583 197.76 484.131 196.444L473.777 204.167C473.777 204.167 468.118 208.307 473.017 209.815C473.017 209.815 481.307 211.698 487.188 205.857",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M487.945 219.418C487.945 219.418 481.922 226.291 475.333 223.224C474.578 222.895 473.969 222.303 473.619 221.558C473.269 220.813 473.202 219.966 473.43 219.175C473.599 218.7 473.875 218.271 474.237 217.92C474.598 217.569 475.036 217.306 475.515 217.15C475.515 217.15 486.538 216.573 487.945 212.271",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M472.976 209.822C472.976 209.822 467.824 215.42 474.282 217.92",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M262.668 127.801C265.766 129.945 269.261 131.448 272.947 132.225C276.633 133.002 280.438 133.036 284.137 132.326C284.137 132.326 287.457 117.922 264.905 115.938C264.905 115.938 253.923 115.655 251.099 126.961C250.445 128.405 249.391 129.631 248.062 130.494C247.586 130.762 247.169 131.122 246.834 131.553C246.498 131.984 246.252 132.477 246.108 133.004C245.778 133.863 245.793 134.817 246.152 135.665C246.511 136.513 247.185 137.188 248.031 137.549C248.031 137.549 249.044 143.622 247.019 145.039C247.019 145.039 243.203 149.837 249.277 152.661C249.277 152.661 253.113 155.364 250.916 158.563C250.497 159.201 250.224 159.923 250.115 160.679C250.007 161.435 250.066 162.205 250.289 162.935C251.159 166.043 253.72 169.818 261.281 166.448L261.14 150.971C261.14 150.971 262.415 130.787 262.668 127.801Z",
    fill: "#522C2C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M285.952 166.071C285.952 166.071 284.393 169.887 279.312 168.096L283.826 196.903C283.826 196.903 273.38 215.407 259.533 196.903L261.092 150.999C261.092 150.999 255.444 156.232 251.061 147.608C251.061 147.608 245.838 137.577 253.885 134.197C253.885 134.197 258.946 132.921 260.1 136.454C260.1 136.454 263.491 129.955 262.499 127.84C262.499 127.84 270.597 133.771 284.11 132.354C285.661 137.226 286.815 142.216 287.562 147.274C287.744 148.56 287.896 149.876 288.007 151.192C288.503 156.647 288.159 162.164 285.952 166.071Z",
    fill: "#FDAFA2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252.606 143.619C252.606 143.619 251.189 135.997 258.041 137.971",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M276.891 144.188V152.943H284.371L276.891 144.188Z",
    fill: "#FF2B49"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M271.629 151.908C273.032 151.908 274.169 150.77 274.169 149.367C274.169 147.964 273.032 146.826 271.629 146.826C270.225 146.826 269.088 147.964 269.088 149.367C269.088 150.77 270.225 151.908 271.629 151.908Z",
    fill: "#FF2B49"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M288.045 151.148C287.752 151.447 287.389 151.668 286.989 151.793C286.59 151.917 286.165 151.941 285.754 151.862C285.343 151.783 284.958 151.603 284.633 151.339C284.308 151.075 284.053 150.735 283.891 150.349C283.729 149.963 283.665 149.543 283.705 149.126C283.744 148.709 283.887 148.309 284.118 147.96C284.35 147.611 284.665 147.325 285.034 147.128C285.403 146.93 285.815 146.826 286.234 146.826C286.719 146.822 287.195 146.963 287.6 147.231C287.782 148.517 287.975 149.833 288.045 151.148Z",
    fill: "#FF2B49"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M283.175 144.39C284.579 144.39 285.716 143.252 285.716 141.849C285.716 140.446 284.579 139.309 283.175 139.309C281.772 139.309 280.635 140.446 280.635 141.849C280.635 143.252 281.772 144.39 283.175 144.39Z",
    fill: "#522C2C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M271.404 145.148C272.807 145.148 273.945 144.01 273.945 142.607C273.945 141.204 272.807 140.066 271.404 140.066C270.001 140.066 268.863 141.204 268.863 142.607C268.863 144.01 270.001 145.148 271.404 145.148Z",
    fill: "#522C2C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M271.63 153.795C271.63 153.795 271.387 160.708 279.727 159.585",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M266.828 162.549V174.311C266.828 174.311 276.849 180.779 281.09 179.22L279.349 168.086C279.349 168.086 273.286 168.055 266.828 162.549Z",
    fill: "#FD8471"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M457.686 244.932L414.748 285.33C394.969 307.082 370.676 291.828 370.676 291.828L337.911 279.752L337.536 325.302H210.584V273.75L171.816 291.828C171.816 291.828 147.523 307.082 127.744 285.33L88.4805 239.851C88.4805 239.851 112.49 215.811 115.901 209.059L155.165 244.375L211.94 206.519C211.94 206.519 221.83 199.433 257.146 193.238C257.146 193.238 267.42 198.724 271.317 199.17C275.163 198.724 285.438 193.238 285.438 193.238C320.754 199.453 330.633 206.519 330.633 206.519L390.01 242.705L438.191 213.786C441.582 220.568 457.686 244.932 457.686 244.932Z",
    fill: "#FF2B49"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M273.391 202.842V318.852",
    stroke: "#522C2C",
    strokeWidth: 1.51832,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M269.225 250.297C270.237 250.297 271.057 249.477 271.057 248.465C271.057 247.453 270.237 246.633 269.225 246.633C268.213 246.633 267.393 247.453 267.393 248.465C267.393 249.477 268.213 250.297 269.225 250.297Z",
    fill: "#522C2C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M269.225 229.498C270.237 229.498 271.057 228.678 271.057 227.666C271.057 226.654 270.237 225.834 269.225 225.834C268.213 225.834 267.393 226.654 267.393 227.666C267.393 228.678 268.213 229.498 269.225 229.498Z",
    fill: "#522C2C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M269.225 271.11C270.237 271.11 271.057 270.289 271.057 269.277C271.057 268.266 270.237 267.445 269.225 267.445C268.213 267.445 267.393 268.266 267.393 269.277C267.393 270.289 268.213 271.11 269.225 271.11Z",
    fill: "#522C2C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M269.225 291.916C270.237 291.916 271.057 291.096 271.057 290.084C271.057 289.072 270.237 288.252 269.225 288.252C268.213 288.252 267.393 289.072 267.393 290.084C267.393 291.096 268.213 291.916 269.225 291.916Z",
    fill: "#522C2C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M269.225 312.721C270.237 312.721 271.057 311.901 271.057 310.889C271.057 309.877 270.237 309.057 269.225 309.057C268.213 309.057 267.393 309.877 267.393 310.889C267.393 311.901 268.213 312.721 269.225 312.721Z",
    fill: "#522C2C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M256.908 197.059C256.908 197.059 261.969 204.326 265.461 207.657C265.764 207.945 266.124 208.164 266.518 208.301C266.913 208.438 267.332 208.488 267.748 208.448C268.163 208.409 268.565 208.281 268.927 208.073C269.289 207.865 269.602 207.581 269.844 207.242C271.014 205.459 272.092 203.618 273.073 201.725",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M289.249 197.059C289.249 197.059 284.188 204.326 280.696 207.657C280.394 207.945 280.034 208.164 279.639 208.301C279.245 208.438 278.826 208.488 278.41 208.448C277.995 208.409 277.592 208.281 277.231 208.073C276.869 207.865 276.556 207.581 276.313 207.242C275.142 205.458 274.061 203.617 273.074 201.725",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M127.137 220.438C122.115 228.816 116.196 236.622 109.484 243.718C106.184 247.203 102.572 250.378 98.6934 253.203",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M120.917 253.204L109.479 243.75",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M118.895 262.737L105.25 247.918",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M99.004 245.295C100.72 245.295 102.112 243.904 102.112 242.188C102.112 240.471 100.72 239.08 99.004 239.08C97.2878 239.08 95.8965 240.471 95.8965 242.188C95.8965 243.904 97.2878 245.295 99.004 245.295Z",
    fill: "#522C2C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M427.387 220.871C427.387 220.871 427.984 231.844 436.719 244.344C439.428 248.289 442.495 251.976 445.88 255.357",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M425.219 254.337L436.647 244.883",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M426.104 263.344L439.738 248.525",
    stroke: "#522C2C",
    strokeWidth: 1.01222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M445.506 247.451C447.222 247.451 448.613 246.06 448.613 244.344C448.613 242.628 447.222 241.236 445.506 241.236C443.79 241.236 442.398 242.628 442.398 244.344C442.398 246.06 443.79 247.451 445.506 247.451Z",
    fill: "#522C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankuBg);
export default __webpack_public_path__ + "static/media/thanku-bg.0c261a2be23d4e89b2570bb666b45c5f.svg";
export { ForwardRef as ReactComponent };